import { render, staticRenderFns } from "./InputUploadGroup.vue?vue&type=template&id=3c2a88e8&scoped=true"
import script from "./InputUploadGroup.vue?vue&type=script&lang=js"
export * from "./InputUploadGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2a88e8",
  null
  
)

export default component.exports